import { useMemo } from 'react';

import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';
import { useGetShareContent } from './useGetShareContent';
import { useGetShareTrackingData } from './useGetShareTrackingData';

export function useShareOptions(): ShareActionsOptions<Channel> {
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();

	return useMemo(
		() => ({
			trackingEventName: 'share_dm_response',
			getContent,
			getTrackingData,
		}),
		[getContent, getTrackingData],
	);
}
